import { render, staticRenderFns } from "./investSearch.vue?vue&type=template&id=8d53df16"
import script from "./investSearch.vue?vue&type=script&lang=js"
export * from "./investSearch.vue?vue&type=script&lang=js"
import style0 from "./investSearch.vue?vue&type=style&index=0&id=8d53df16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports